<template>
  <div class="share-buttons" :class="{ initialized: state.initialized }">
    <ShareNativeShareButton
      v-if="props.title && state.nativeShare && !state.isDesktop"
      :article-title="props.title"
      :analytics="analytics"
    />
    <ShareCopyLinkButton v-else-if="state.pageUrl" :url="state.pageUrl" :analytics="analytics" />
  </div>
</template>

<script setup lang="ts">
/* We always show the copy button, unless it's a mobile device that supports nativeShare */
import { isDevice } from '~/utils/device';
import useWebShare from '~/composables/useWebShare';
import type { IAnalytics } from '~~/types/local_types';

interface IProps {
  title?: string;
  url?: string;
  analytics?: IAnalytics;
}

interface IState {
  isDesktop: boolean;
  pageUrl?: string;
  nativeShare: boolean;
  initialized: boolean;
}

const { webShareApiSupported } = useWebShare();

const props = defineProps<IProps>();
const state = reactive<IState>({
  isDesktop: false,
  pageUrl: undefined,
  nativeShare: true,
  initialized: false,
});

onMounted(async () => {
  state.nativeShare = webShareApiSupported.value;
  state.pageUrl = `${window.location.href.split(window.location.pathname)[0]}${props.url || ''}`;
  state.isDesktop = await isDevice.desktop();
  state.initialized = true;
});
</script>

<style scoped lang="postcss">
.share-buttons {
  display: inline;
  padding-top: var(--unit-4);
  margin-bottom: var(--unit-8);

  pointer-events: none;

  &.initialized {
    pointer-events: unset;
  }
}
</style>
